import React from 'react';
import CheckCircleOutlineOutlinedIcon from '@material-ui/icons/CheckCircleOutlineOutlined';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';
import ErrorOutlineOutlinedIcon from '@material-ui/icons/ErrorOutlineOutlined';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

export const snackbarIconVariant = {
  success: <CheckCircleOutlineOutlinedIcon />,
  error: <CancelOutlinedIcon />,
  warning: <ErrorOutlineOutlinedIcon />,
  info: <InfoOutlinedIcon />,
};
